import React, { useEffect, useState } from "react";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { SHIFT, TIME_KEEPING_LEAVE_TYPE, weekDayNames } from "../../utils/Utils";


const MyTimeKeepingScheduling = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    monthYear: searchParams.get("monthYear") || moment().format("YYYY-MM"),
  });

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => {
        const mm = moment(item.date, "YYYY-MM-DD");
        return `${mm.format("DD")}(${weekDayNames[mm.day()]})`;
      },
    },
    {
      Header: "Chấm công",
      accessor: (item) => {
        if (item.shift) {
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                const newParams = new URLSearchParams({
                  startDate: moment(item.date).startOf("days").toDate(),
                  endDate: moment(item.date).endOf("days").toDate(),
                  employeeId: item.employeeId || "",
                  shift: item.shift || "",
                });
                history.push({
                  pathname: "/my-time-keeping",
                  search: newParams.toString(),
                });
              }}
            >
              <Row className="d-inline">
                <Col sm={12}>Ca {SHIFT[item.shift]}</Col>
                {item.leaveType ? (
                  <Col sm={12} className={`text-in-one-line`}>
                    {TIME_KEEPING_LEAVE_TYPE[item.leaveType]}
                  </Col>
                ) : (
                  <Col sm={12} className={`text-in-one-line`}>
                    {item.workingHour} giờ + {item.extraHour} giờ
                  </Col>
                )}
                {item.agreedBy ? (
                  ""
                ) : (
                  <small style={{ color: "red" }}>Chưa xác nhận</small>
                )}
              </Row>
            </div>
          );
        }
        return "";
      },
    },
  ];

  useEffect(() => {
    const { monthYear } = filter;

    const newParams = new URLSearchParams({
      monthYear,
    });

    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    GET(
      "employee/keepingtime/my-scheduling",
      {
        monthYear,
      },
      true
    ).then((resp) => {
      const { data: rows } = resp;
      setData(rows);
    });
  }, [filter]);

  return (
    <React.Fragment>
      <Head title="Thời gian biểu"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Thời gian biểu</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h5>
                    <small>Tổng: </small>
                    {data.reduce(
                      (prev, cur) => prev + (cur.calculatedHour || 0),
                      0
                    )}{" "}
                    giờ
                  </h5>
                  <h5>
                    <small> Giờ làm: </small>
                    {data.reduce(
                      (prev, cur) => prev + (cur.workingHour || 0),
                      0
                    )}{" "}
                    giờ
                  </h5>
                  <h5>
                    <small> Giờ làm thêm: </small>
                    {data.reduce(
                      (prev, cur) => prev + (cur.extraHour || 0),
                      0
                    )}{" "}
                    giờ
                  </h5>
                  <h5>
                    <small>Giờ thưởng thêm: </small>
                    {data.reduce(
                      (prev, cur) =>
                        prev +
                        (cur.calculatedHour || 0) -
                        (cur.workingHour || 0) -
                        (cur.extraHour || 0),
                      0
                    )}{" "}
                    giờ
                  </h5>
                </div>

                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default MyTimeKeepingScheduling;
